export const lostReason = [
  {
    id: "1",
    si_no: "",
    title: "Client went silent",
    created_date: "25 Sep 2023, 01:22 pm",
    status: "Active",
    action: "",
    key: "1"
  },
  {
    id: "2",
    si_no: "",
    title: "Don't have the budget",
    created_date: "29 Sep 2023, 10:20 pm",
    status: "Active",
    action: "",
    key: "2"
  },
  {
    id: "3",
    si_no: "",
    title: "Doesn't pick up the phone, doesn't respond",
    created_date: "04 Oct 2023, 08:30 am",
    status: "Active",
    action: "",
    key: "3"
  },
  {
    id: "4",
    si_no: "",
    title: "Lack of expertise",
    created_date: "17 Oct 2023, 11:45 am",
    status: "Inactive",
    action: "",
    key: "4"
  },
  {
    id: "5",
    si_no: "",
    title: "Not responsible",
    created_date: "26 Oct 2023, 04:10 pm",
    status: "Active",
    action: "",
    key: "5"
  },
  {
    id: "6",
    si_no: "",
    title: "They couldn't afford our services",
    created_date: "08 Nov 2023, 05:23 am",
    status: "Active",
    action: "",
    key: "6"
  },
  {
    id: "7",
    si_no: "",
    title: "Went with our competitor",
    created_date: "11 Nov 2023, 02:32 pm",
    status: "Active",
    action: "",
    key: "7"
  },
];
